export enum EMajorType {
  ObstetricsAndGynecology = 4
}
